/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {assetStateColorMap} from '../helpers/assetStateColorMap';
import {IconStatus} from '../types/types';
import {StatusIcon} from './StatusIcon';

export interface AssetStatusType {
  status: string;
  style?: any;
}

/**
 * @AssetStatusIcon
 *
 * The main purpose of the AssetStatusIcon is to provide a map from the status
 * of the asset that we may receive from the CVS (received as a prop here using the
 * AssetStatus enum) and map it to the appropriate StatusIcon type
 * (which just determines the color).
 *
 * ```typescript
 *     <AssetStatusIcon status={AssetStatus.ENABLED} />
 *
 * ```
 */
export const AssetStatusIcon = ({status, style}: AssetStatusType) => (
  <StatusIcon type={assetStateColorMap[status] || IconStatus.offline} style={style} />
);
